import { assignInlineVars } from "@vanilla-extract/dynamic";
import { Flex, HelpIndicator, Text } from "@jsq/ds/core";
import { Icon, IconType } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ChangeIconColors } from "~/pages/Compliance/riskRating/constants";
import {
  cursorStyle,
  hoverIcon,
  itemWidth,
  riskRatingCellContainer,
  riskRatingLabelWrapper,
} from "./styles_vanilla.css";

interface Props {
  hasIcon?: boolean;
  iconType?: IconType | null;
  color: Colors;
  text: string;
  changeIcon?: IconType | null;
  showHoverInspector?: boolean;
  isFullWidth?: boolean;
  onInspectRiskRating?: () => void;
}

export const RiskRatingCell = ({
  hasIcon = false,
  iconType,
  color,
  text,
  changeIcon,
  onInspectRiskRating,
  showHoverInspector = false,
  isFullWidth = false,
}: Props) => {
  const fullCellClickable = onInspectRiskRating && !showHoverInspector;
  const content = (
    <Flex
      className={riskRatingCellContainer}
      justifyContent="space-between"
      alignItems="center"
      gap={Sizes.SM}
      style={assignInlineVars({
        [cursorStyle]: fullCellClickable ? "pointer" : "default",
        [itemWidth]: isFullWidth ? "100%" : "fit-content",
      })}
      onClick={fullCellClickable ? onInspectRiskRating : undefined}
    >
      <Flex alignItems="center" gap={Sizes.SM} className={riskRatingLabelWrapper}>
        {hasIcon && iconType && (
          <Icon
            data-testid="risk-rating-icon"
            data-cy="risk-rating-icon"
            type={iconType}
            color={color}
          />
        )}
        <Text
          data-testid="risk-rating-label"
          data-cy="risk-rating-label"
          style={{ color: color }}
        >
          {text}
        </Text>
      </Flex>
      {showHoverInspector && (
        <HelpIndicator id="inspect-risk-rating" content="Inspect risk rating">
          <Flex alignItems="center" className={hoverIcon}>
            <Icon
              type="search"
              color={Colors.Primary600}
              onClick={onInspectRiskRating}
              data-testid="inspect-risk-rating-icon"
            />
          </Flex>
        </HelpIndicator>
      )}
      {changeIcon && (
        <Flex alignItems="center">
          <Icon
            data-testid="change-icon"
            type={changeIcon}
            color={ChangeIconColors[changeIcon]}
          />
        </Flex>
      )}
    </Flex>
  );

  return fullCellClickable ? (
    <HelpIndicator content="Inspect risk rating" id="inspect-risk-rating">
      {content}
    </HelpIndicator>
  ) : (
    content
  );
};
